import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScreenSizeService {
  private readonly _screenWidth = new BehaviorSubject<number>(0);
  screenWidth$ = this._screenWidth.asObservable();

  private readonly _screenHeight = new BehaviorSubject<number>(0);
  screenHeight$ = this._screenHeight.asObservable();

  constructor() {
    this._screenWidth.next(window.innerWidth);
    this._screenHeight.next(window.innerHeight);

    window.addEventListener('resize', () => {
      this._screenWidth.next(window.innerWidth);
      this._screenHeight.next(window.innerHeight);
    });
  }
}
